import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ROLES } from '../constants/roles.constants';

@Injectable({
  providedIn: 'root'
})
export class GestionnaireOrAnimateurGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (!this.authService.isLoggedIn()) {
      this.router.navigate(['/auth/login']);
      return false;
    }

    const currentUser = this.authService.getCurrentUser();
    
    // Vérifier si l'utilisateur a le rôle gestionnaire EHPAD ou animateur
    if (currentUser && (currentUser.role?.nom === ROLES.EHPAD || currentUser.role?.nom === ROLES.ANIMATEUR)) {
      return true;
    }

    // Rediriger selon le rôle de l'utilisateur
    if (currentUser) {
      switch (currentUser.role?.nom) {
        case ROLES.ADMIN:
        case ROLES.SUPERADMIN:
          this.router.navigate(['/dashboard']);
          break;
        case ROLES.FAMILLE:
          this.router.navigate(['/dashboard-famille']);
          break;
        case ROLES.PRATICIEN:
        case ROLES.KINE:
          this.router.navigate(['/dashboard-praticien']);
          break;
        default:
          this.router.navigate(['/auth/login']);
          break;
      }
    } else {
      this.router.navigate(['/auth/login']);
    }

    return false;
  }
}
